import React from "react";
import { Box } from "@mui/material";
import { AppConfig } from "Constants";

import useStyles from "./styles";
import Button, { Color } from "Components/Form/Button";

interface ContentCardProps {
  children?: React.ReactNode;
  title?: string;
  content?: string;
  icon?: React.ReactNode;
  actionText?: string;
  onActionClick?: () => void;
  actionColor?: Color;
}

export const AppPageCardInform: React.FC<ContentCardProps> = ({ 
  children,
  title,
  content,
  icon,
  actionText,
  onActionClick,
  actionColor = Color.SECONDARY_DARK
}) => {
  const classes = useStyles();

  const renderPropsContent = () => (
    <>
      {icon && (
        <Box className={classes.icon}>
          {icon}
        </Box>
      )}
      {title && <div className={classes.title}>{title}</div>}
      {content && <div className={classes.content}>{content}</div>}
      {actionText && onActionClick && (
        <Button 
          className={classes.closeWindowButton} 
          customColor={actionColor}
          onClick={onActionClick}
        >
          {actionText}
        </Button>
      )}
    </>
  );

  return (
    <div className={classes.container}>
      <Box className={classes.box}>
        <Box className={classes.items}>
          <img
            src={AppConfig.appLogo}
            height="32px"
            className={classes.image}
            alt="Logo"
          />
          {children || renderPropsContent()}
        </Box>
      </Box>
    </div>
  );
};